import React from 'react'
import { Tooltip as ReactTippy } from 'react-tippy'

const Tooltip = ({ children, title, ...override }) => {
  if (!title) return children
  return (
    <ReactTippy
      title={title}
      arrow={true}
      touchHold={true}
      animation="shift"
      duration={250}
      size="small"
      arrowSize="small"
      position="top"
      {...override}
    >
      {children}
    </ReactTippy>
  )
}

export default Tooltip



// WEBPACK FOOTER //
// ./src/components/Tooltip.js